var exports = {
  "p": "SidebarResizeHandle.module__handle___aFlhVG",
  "q": "SidebarResizeHandle.module__indicator___aFlhVG",
};

module.exports = exports;
